module.exports = __webpack_public_path__ + "img/norway-cervical-cancer-female.87d5320d.png";